import { render } from "./IndexPage.vue?vue&type=template&id=1b2fad99"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=1b2fad99&lang=scss"
script.render = render

export default script